<div class="page-section-container">
    <div class="page-section title primary-background">
        <title-small-section></title-small-section>
    </div>
    <div id="first-section" class="page-section">
        <div class="page-section-content">
            <div class="d-flex fd-col">
                <div class="secondary-lead text-center">
                    <h2>Frequently Asked Questions</h2>
                </div>
            </div>
        </div>
    </div>
    <app-faqs [faqLibrary]="faqLibrary"></app-faqs>
</div>